webpackJsonpPois([1],{

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1105);

__webpack_require__(359);

var _client = __webpack_require__(360);

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _client2.default)(window.__initialState);

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[1104]);


// WEBPACK FOOTER //
// pois.4b613b04f86978a8c45c.js